import * as React from 'react';
import styled from 'styled-components';

import APIErrorIcon from './icons/APIErrorIcon';

const OuterWrapper = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 12rem;
`;

const InnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: 600px) {
        flex-direction: row;
    }

    & > div {
        flex-grow: 1;
        font-size: 1.25rem;
    }

    & > svg {
        flex-shrink: 0;
    }
`;

const StyledAPIErrorIcon = styled(APIErrorIcon)`
    width: 10rem;
    height: 10rem;
    margin-right: 1rem;
`;

interface IProps {
    error: string;
}

function Error({ error }: IProps): JSX.Element {
    return <OuterWrapper>
        <InnerWrapper>
            <StyledAPIErrorIcon />
            <div>{error}</div>
        </InnerWrapper>
    </OuterWrapper>;
}

export default React.memo(Error);
